import { render, staticRenderFns } from "./DatacenterNewHg.vue?vue&type=template&id=f2a7511c&scoped=true"
import script from "./DatacenterNewHg.vue?vue&type=script&lang=js"
export * from "./DatacenterNewHg.vue?vue&type=script&lang=js"
import style0 from "./DatacenterNewHg.vue?vue&type=style&index=0&id=f2a7511c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a7511c",
  null
  
)

export default component.exports